import React from 'react';

import { MonthlyActiveUser } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';

import { ViewCustomerType } from '../ViewCustomerType';

export type IMonthlyActiveUserProps = {
    monthlyActiveUser?: MonthlyActiveUser;
};

export const ViewMonthlyActiveUser = ({ monthlyActiveUser }: IMonthlyActiveUserProps) => {
    return (
        <Column>
            <Text type="h500">Monthly active user terms</Text>
            <ViewCustomerType customerTypes={monthlyActiveUser!.customerType!} />
        </Column>
    );
};
